function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  className: "Cargando_svg__not-color",
  cx: 8,
  cy: 8,
  r: 7.4,
  stroke: "#B8B8B8"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.461.539C7.461.24 7.702 0 8 0c1.347 0 3.328.474 4.985 1.705C14.665 2.954 16 4.975 16 8a.539.539 0 11-1.078 0c0-2.66-1.152-4.369-2.58-5.43C10.89 1.492 9.14 1.078 8 1.078a.539.539 0 01-.539-.54z",
  fill: "#2D2D2D"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  from: "0 8 8",
  to: "360 8 8",
  dur: "1.5s",
  repeatCount: "indefinite"
}));
function SvgCargando(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default __webpack_public_path__ + "/img/Cargando.svg";
export { SvgCargando as ReactComponent };